<template>
    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        @submit.prevent='sendReport'
    >
        <v-container>
            <v-row>
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ارسال اعلان جدید</h3>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        autofocus
                        v-model='model.title'
                        :rules='rules.title'
                        type='text'
                        placeholder='عنوان'
                        required
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>عنوان
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-alert
                        text
                        border='left'
                        prominent
                        color='info' class='mx-auto mb-3'
                    >
                        <p class='text--primary subtitle-2'>نمونه ای از گزارشاتی که توسط مدیرمجموعه اعلام میشود:</p>
                        <v-card-subtitle class='text--secondary pa-0'>
                            <div class='mb-3'>به طور مثال در تاریخ.... ساعت.... نظافت راهروهای مجموعه انجام خواهد شد.
                            </div>
                            <div class='mb-3'>به طور مثال فردا مورخه..... طبق اطلاعیه سازمان برق از ساعت... تا.... برق
                                قطع خواهد
                                شد.
                            </div>
                            <div>به طور مثال به علت تعمیرات آسانسور فردا مورخه... از ساعت... تا... آسانسور خارج از دسترس
                                میباشد.
                            </div>
                        </v-card-subtitle>
                    </v-alert>
                    <form ref='myFileInputForm'>
                        <vue-editor
                            ref='editor'
                            :editorToolbar='toolbar'
                            v-model='model.content'
                            placeholder='متن'
                            :use-custom-image-handler='true'
                            @image-added='handleImageAdded'
                        ></vue-editor>
                    </form>
                </v-col>
                <v-col cols='12'>
                    <v-btn
                        block
                        name='submit'
                        :disabled='!valid || sendReportLoading'
                        color='primary'
                        type='submit'
                        @click='validate'
                        :loading='sendReportLoading'
                    >
                        ثبت
                    </v-btn>
                    <v-btn
                        outlined
                        class='mt-2'
                        block
                        name='cancel'
                        @click='goBack'
                    >انصراف
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model='uploadDialog'
            persistent
        >
            <v-card>
                <v-row
                    class='fill-height ma-0 text-center'
                    align='center'
                    justify='center'
                >
                    <v-col cols='12'>
                        <p>
                            در حال بارگذاری فایل
                        </p>
                        <v-progress-circular
                            indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import { VueEditor } from 'vue2-editor';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'Form',
        components: {
            VueEditor
        },
        data: () => ({
            sendReportLoading: false,
            uploadDialog: false,
            valid: true,
            model: {
                title: '',
                content: '',
                apartment: '',
                type: 'NEW_REPORT_BY_MANAGER'
            },
            rules: {
                title: [
                    v => !!v || 'عنوان اجباری میباشد',
                    v => v.length > 4 ? true : 'باید حداقل شامل ۵ حرف باشد'
                ]
            },
            toolbar: [
                [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'header': 1 }, { 'header': 2 }],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                ['image']
            ]
        }),
        methods: {
            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page);
            },
            handleImageAdded(file, Editor, cursorLocation) {
                const formData = new FormData();
                formData.append('photo', file);
                const imgList = ['image/png', 'image/jpeg', 'image/gif'];
                if (imgList.includes(file.type)) {
                    if (file.size < 20971520) {
                        this.uploadDialog = true;
                        axios
                            .post(
                                `api/upload/photos/reports--${this.model.apartment}`
                                ,
                                formData
                            )
                            .then(async (res) => {
                                this.$refs.myFileInputForm.reset();
                                let url = res.data.url;
                                this.uploadDialog = false;
                                let message = 'تصویر شما ثبت شد';
                                await this.$snackbar.showMessage({ content: message, color: 'success' });
                                Editor.insertEmbed(cursorLocation, 'image', `${this.public_url}/${url}`);
                            })
                            .catch((err) => {
                                let message = 'تصویر بارگذاری نشد';
                                this.$snackbar.showMessage({ content: message, color: 'warning' });
                                this.uploadDialog = false;
                                console.error(err);
                            });
                    } else {
                        this.$snackbar.showMessage({
                            content: 'حداکثر حجم فایل ۲۰ مگابایت میباشد',
                            color: 'warning'
                        });
                    }
                } else {
                    this.$snackbar.showMessage({
                        content: 'فرمت فایل نامعتبر میباشد \n فرمت های قابل قبول عبارت اند از \n ' +
                            'jpeg, png, gif',
                        color: 'warning'
                    });
                }
            },

            validate() {
                this.$refs.form.validate();
            },
            async sendReport() {
                if (this.$refs.editor.$refs.quillContainer.innerText.length <= 1) {
                    return this.$snackbar.showMessage({ content: 'متن گزارش را وارد کنید', color: 'red' });
                }
                this.model.apartment = this.apartment_id;
                this.sendReportLoading = true;
                await axios
                    .post(
                        `/api/apartments/${this.apartment_id}/reports`,
                        this.model
                    )
                    .then(async ({ data }) => {
                        let message = 'گزارش شما ثبت شد.';
                        await this.$snackbar.showMessage({ content: message, color: 'success' });
                        await this.$router.push({
                            name: 'Report',
                            params: {
                                report_id: data.report._id,
                                report: data.report
                            }
                        });
                    })
                    .catch(async () => {
                        this.$refs.editor.quill.format('align', 'right');
                        await this.$snackbar.showMessage({
                            content: 'خطا در سرور',
                            color: 'red'
                        });
                    });
                this.sendReportLoading = false;
            },
            ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.apartment_id = this.$route.params.apartment_id;
            await this.setBreadCrumbsTemp({
                key: 'newReport',
                value: {
                    text: `اعلان جدید`,
                    href: `/apartments/${this.$route.params.apartment_id}/reports/new`
                }
            });
        },
        mounted() {
            this.$refs.editor.quill.format('align', 'right');
        },
        async updated() {
            await this.showBreadCrumbs(['home', 'apartmentDetail', 'apartmentReports', 'newReport']);
        },
        computed: {
            ...mapState(['public_url'])
        }

    };
</script>
